import React, { useState } from 'react'
import { Formik } from 'formik'
import Form, {
  Row,
  Col,
  Label,
  Field,
  Button,
  Title,
  ButtonRow,
  ErrorMessage,
  MaskedInput
} from '../../../components/Form'
import Modal from '../../../components/Modal'
import { validationSchema, expirationDateMask } from './utils'

const CreditCardModal = props => {
  const { isOpen, onRequestClose, onCreateCard } = props

  const [cardError, setCardError] = useState('')

  const onClose = () => {
    setCardError('')
    onRequestClose()
  }

  const onSubmit = (values, { setSubmitting }) => {
    onCreateCard(values).then(({ success, error }) => {
      setSubmitting(false)
      if (success) {
        onClose()
      } else {
        setCardError(error)
      }
    })
  }

  return (
    <Modal
      size="md"
      title="Add Credit Card"
      isOpen={isOpen}
      onRequestClose={onClose}>
      <Formik
        isInitialValid={false}
        initialValues={{
          card: '',
          expiration: '',
          cvv: '',
          setDefault: true
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}>
        {({
          isSubmitting,
          values,
          setFieldValue,
          isValid,
          handleBlur,
          handleChange
        }) => {
          const setDefaultCard = () => {
            setFieldValue('setDefault', !values.setDefault, true)
          }

          return (
            <Form>
              <Title>Credit Card</Title>
              <div className="credit_card_form_grid">
                <Col className="card_number">
                  <Label>Card Number</Label>
                  <Field
                    type="text"
                    name="card"
                    placeholder="0000 0000 0000 0000"
                  />
                  <ErrorMessage name="card" component="div" />
                </Col>
                <Col className="expiration">
                  <Label>Expiration</Label>
                  <MaskedInput
                    name="expiration"
                    placeholder="MM/YY"
                    value={values.expiration}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    mask={expirationDateMask}
                  />
                  <ErrorMessage name="expiration" component="div" />
                </Col>
                <Col className="cvv">
                  <Label>CVV</Label>
                  <Field type="text" name="cvv" placeholder="3 digits" />
                  <ErrorMessage name="cvv" component="div" />
                </Col>
              </div>

              <Row>
                <Col>
                  <Field
                    type="checkbox"
                    name="setDefault"
                    checked={values.setDefault}
                    onClick={setDefaultCard}
                    label="Set as my Default Payment Method"
                  />
                </Col>
              </Row>

              {!!cardError && (
                <Row>
                  <Col>
                    <div className="cookunity__form_error_message">
                      {cardError}
                    </div>
                  </Col>
                </Row>
              )}

              <ButtonRow>
                <Button
                  dark
                  large
                  type="submit"
                  loading={isSubmitting}
                  disabled={!isValid}>
                  Add card
                </Button>
                <Button type="button" transparent large onClick={onClose}>
                  Cancel
                </Button>
              </ButtonRow>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}

export default CreditCardModal



// WEBPACK FOOTER //
// ./src/modules/Checkout/PaymentDetails/CreditCardModal.jsx